import { reactive } from 'vue';

const instances = reactive([]);

export function useMultiselect() {
    const register = (instance: any) => {
        instances.push(instance);
    };

    const unregister = (instance: any) => {
        const index = instances.indexOf(instance);
        if (index !== -1) {
            instances.splice(index, 1);
        }
    };

    const closeAll = () => {
        for (const multiselect of instances) {
            if (multiselect) {
                multiselect.close();
            }
        }
    };
    const blurAll = () => {
        for (const multiselect of instances) {
            /* multiselect.wrapper už občas nemusí být na stránce
            a je null - komponenta se na něj ale interně odkazuje, takže
            to nejdříve zkontrolujeme a potom voláme blur */
            if (multiselect?.wrapper) {
                multiselect.blur();
            }
        }
    };

    return { register, unregister, closeAll, blurAll, multiselects: instances  };
}
